/* Squishlings storefront behaviour: midnight countdowns, cart reservation timer,
   bundle picker, cart upsells, delivery estimate, sticky bar and scroll reveal. */
(function () {
  'use strict';
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---- Countdown to the visitor's next local midnight; resets every night ---- */
  function msToMidnight() {
    var now = new Date();
    var next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    return next - now;
  }
  function tickCountdowns() {
    var ms = msToMidnight();
    var h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000), s = Math.floor((ms % 60000) / 1000);
    document.querySelectorAll('[data-sq-cd]').forEach(function (el) {
      var hh = el.querySelector('[data-h]'), mm = el.querySelector('[data-m]'), ss = el.querySelector('[data-s]');
      if (hh) { hh.textContent = pad(h); mm.textContent = pad(m); ss.textContent = pad(s); }
      else el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    });
    document.querySelectorAll('[data-sq-today]').forEach(function (el) {
      el.textContent = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    });
  }

  /* ---- Cart timer: starts when the cart gets items, really empties the cart when it runs out ---- */
  var RES_KEY = 'bh_cart_expires', clearing = false;
  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function expireCart() {
    if (clearing) return; clearing = true;
    var drawer = document.querySelector('cart-drawer');
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        store(RES_KEY, null);
        if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        if (drawer && res.sections && drawer.renderContents) { try { drawer.renderContents(res); drawer.classList.add('is-empty'); } catch (e) { window.location.reload(); } }
      })
      .catch(function () {})
      .finally(function () { clearing = false; });
  }
  function reserveTick() {
    var els = document.querySelectorAll('[data-sq-reserve]');
    var until = parseInt(read(RES_KEY), 10);
    if (!els.length) {                       // cart is empty: forget any old timer
      if (until && until > Date.now()) store(RES_KEY, null);
      if (until && until <= Date.now()) store(RES_KEY, null);
      return;
    }
    var mins = parseInt(els[0].getAttribute('data-sq-reserve'), 10) || 10;
    if (!until) { until = Date.now() + mins * 60000; store(RES_KEY, String(until)); }
    var left = until - Date.now();
    if (left <= 0) { els.forEach(function (el) { var t = el.querySelector('[data-t]') || el; t.textContent = '00:00'; }); expireCart(); return; }
    var txt = pad(Math.floor(left / 60000)) + ':' + pad(Math.floor((left % 60000) / 1000));
    els.forEach(function (el) { var t = el.querySelector('[data-t]') || el; t.textContent = txt; });
  }

  /* ---- Estimated delivery window from business days (matches the shipping policy) ---- */
  function addBusinessDays(d, n) {
    var r = new Date(d);
    while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
    return r;
  }
  function deliveryEstimates() {
    document.querySelectorAll('[data-sq-eta]').forEach(function (el) {
      var parts = (el.getAttribute('data-sq-eta') || '3,5').split(',');
      var f = { month: 'short', day: 'numeric' };
      var today = new Date();
      var a = addBusinessDays(today, parseInt(parts[0], 10)).toLocaleDateString('en-US', f);
      var b = addBusinessDays(today, parseInt(parts[1], 10)).toLocaleDateString('en-US', f);
      el.textContent = a + ' – ' + b;
    });
  }

  /* ---- Bundle picker: sets quantity on the product form and updates prices ---- */
  function initBundles(root) {
    (root || document).querySelectorAll('[data-sq-bundles]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '');
      var formId = wrap.getAttribute('data-form');
      var form = document.getElementById(formId);
      var qtyInput = form && form.querySelector('input[name="quantity"]');
      var section = wrap.closest('[data-sq-product]');
      function apply(opt) {
        wrap.querySelectorAll('.sq-bundle').forEach(function (o) { o.classList.toggle('is-active', o === opt); o.setAttribute('aria-checked', o === opt); });
        var q = opt.getAttribute('data-qty');
        if (qtyInput) qtyInput.value = q;
        if (section) {
          section.querySelectorAll('[data-sq-atc-price]').forEach(function (p) { p.textContent = opt.getAttribute('data-price-label'); });
          section.querySelectorAll('[data-sq-atc-compare]').forEach(function (p) { p.textContent = opt.getAttribute('data-compare-label'); });
        }
        document.querySelectorAll('[data-sq-sticky-qty]').forEach(function (s) { s.value = q; });
        document.querySelectorAll('[data-sq-sticky-price]').forEach(function (p) { p.textContent = opt.getAttribute('data-price-label'); });
      }
      wrap.querySelectorAll('.sq-bundle').forEach(function (opt) {
        opt.addEventListener('click', function () { apply(opt); });
        opt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); apply(opt); } });
      });
      var start = wrap.querySelector('.sq-bundle.is-active') || wrap.querySelector('.sq-bundle');
      if (start) apply(start);
    });
  }

  /* ---- Add to cart from anywhere (cart upsells, product cards, bundle nudges) ---- */
  function addToCart(id, qty, btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: id, quantity: qty || 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { alert(res.description || res.message || 'Could not add to cart'); return; }
      if (drawer && res.sections) {
        res.id = id;
        drawer.renderContents(res);
      } else { window.location.href = '/cart'; }
    }).catch(function () { window.location.href = '/cart'; }).finally(function () {
      if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sq-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(parseInt(btn.getAttribute('data-sq-add'), 10), parseInt(btn.getAttribute('data-qty') || '1', 10), btn);
  });
  window.SQ = { addToCart: addToCart };

  /* ---- Change design (variant) of a line directly in the cart drawer ---- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-bh-variant-switch]');
    if (!sel) return;
    var line = parseInt(sel.getAttribute('data-line'), 10), qty = parseInt(sel.getAttribute('data-qty'), 10) || 1, id = parseInt(sel.value, 10);
    var drawer = document.querySelector('cart-drawer');
    sel.disabled = true;
    var keys = (sel.getAttribute('data-bh-keys') || '').split(',').filter(Boolean), upd = {};
    keys.forEach(function (k) { upd[k] = 0; });
    var clear = keys.length > 1
      ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
      : fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: 0 }) });
    clear
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (drawer && res.sections && drawer.renderContents) { res.id = id; drawer.renderContents(res); } else window.location.reload(); })
      .catch(function () { window.location.reload(); });
  });

  /* ---- Discount code field in the cart drawer ---- */
  function setDiscount(code) {
    var drawer = document.querySelector('cart-drawer');
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (drawer && res.sections && drawer.renderContents) drawer.renderContents(res); else window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-bh-code]');
    if (!f) return;
    e.preventDefault();
    var code = (f.querySelector('input[name="code"]').value || '').trim();
    if (!code) return;
    var btn = f.querySelector('button'); if (btn) btn.setAttribute('aria-busy', 'true');
    setDiscount(code);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-bh-code-remove]')) return;
    e.preventDefault();
    setDiscount('');
  });

  /* ---- Variant pills: update the form's variant id and the visible prices ---- */
  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-sq-variant]');
    if (!r) return;
    var form = document.getElementById(r.getAttribute('data-form'));
    if (form) form.querySelector('input[name="id"]').value = r.value;
    var sec = r.closest('[data-sq-product]');
    if (sec) sec.querySelectorAll('[data-sq-price], [data-sq-atc-price]').forEach(function (p) { p.textContent = r.getAttribute('data-price'); });
    document.querySelectorAll('[data-sq-sticky-price]').forEach(function (p) { p.textContent = r.getAttribute('data-price'); });
    var was = sec && sec.querySelector('.sq-pdp__price-was'); if (was && r.getAttribute('data-compare')) was.textContent = r.getAttribute('data-compare');
    var pos = parseInt(r.getAttribute('data-media-pos') || '0', 10), g = sec && sec.querySelector('[data-sq-gallery]');
    if (g && g.__go && pos > 0) g.__go(pos - 1);
  });

  /* ---- Sticky add-to-cart bar appears when the main buy button scrolls away ---- */
  function initSticky() {
    var bar = document.querySelector('[data-sq-sticky]');
    var anchor = document.querySelector('[data-sq-main-atc]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(anchor);
  }

  /* ---- Gallery: thumbnails + swipe ---- */
  function initGalleries() {
    document.querySelectorAll('[data-sq-gallery]:not([data-ready])').forEach(function (g) {
      g.setAttribute('data-ready', '');
      var track = g.querySelector('[data-track]');
      var thumbs = g.querySelectorAll('[data-thumb]');
      var slides = g.querySelectorAll('[data-slide]');
      function go(i) {
        if (!slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      g.__go = go;
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = g.querySelector('[data-prev]'), next = g.querySelector('[data-next]');
      function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      if (prev) prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
      if (next) next.addEventListener('click', function () { go(Math.min(slides.length - 1, current() + 1)); });
      track.addEventListener('scroll', function () {
        var i = current();
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        g.querySelectorAll('[data-dot]').forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
    });
  }

  /* ---- Video tiles: play in view, tap to unmute ---- */
  function initVideos() {
    var vids = document.querySelectorAll('[data-sq-video] video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) {
      io.observe(v);
      var tile = v.closest('[data-sq-video]');
      tile.addEventListener('click', function () {
        var muted = !v.muted;
        document.querySelectorAll('[data-sq-video] video').forEach(function (o) { o.muted = true; o.closest('[data-sq-video]').classList.remove('is-sound'); });
        v.muted = muted; tile.classList.toggle('is-sound', !muted);
        if (!muted) { v.currentTime = 0; v.play(); }
      });
    });
  }

  /* ---- Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.sq-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- Rotating announcement messages ---- */
  function initAnnouncements() {
    document.querySelectorAll('[data-sq-rotate]:not([data-ready])').forEach(function (r) {
      r.setAttribute('data-ready', '');
      var items = r.querySelectorAll('[data-item]'); if (items.length < 2) return;
      var i = 0, ms = parseInt(r.getAttribute('data-sq-rotate'), 10) || 4000;
      setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, ms);
    });
  }

  /* ---- Rails: arrow buttons scroll the track by most of its visible width ---- */
  function initRails() {
    document.querySelectorAll('[data-sq-rail]:not([data-ready])').forEach(function (r) {
      r.setAttribute('data-ready', '');
      var t = r.querySelector('[data-rail-track]'), prev = r.querySelector('[data-rail-prev]'), next = r.querySelector('[data-rail-next]');
      if (!t) return;
      function upd() { if (prev) prev.disabled = t.scrollLeft < 8; if (next) next.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8; }
      function go(dir) { t.scrollBy({ left: dir * Math.max(240, t.clientWidth * 0.8), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      t.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }

  function boot() {
    initRails();
    tickCountdowns(); reserveTick(); deliveryEstimates();
    initBundles(); initSticky(); initGalleries(); initVideos(); initReveal(); initAnnouncements();
  }
  setInterval(function () { tickCountdowns(); reserveTick(); }, 1000);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  /* the cart drawer re-renders its HTML after every change: re-run the bits that live inside it */
  document.addEventListener('cart:refresh', boot);
  window.addEventListener('load', function () {
    var d = document.getElementById('CartDrawer');
    if (d) new MutationObserver(function () { reserveTick(); deliveryEstimates(); }).observe(d, { childList: true });
  });
})();
